<script>

import { onMount } from 'svelte';
import * as user from '../user.js';
import { replace } from 'svelte-spa-router'

onMount(() =>
{
    user.SignOut();
});




</script>
